<nav class="navbar navbar-transparent navbar-top" role="navigation">
  <div class="container">
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="navbar-header">
      <button id="menu-toggle" type="button" class="navbar-toggle" data-toggle="collapse" data-target="#example">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar bar1"></span>
        <span class="icon-bar bar2"></span>
        <span class="icon-bar bar3"></span>
      </button>
      <a href="http://codesender.pl">
        <div class="logo-container">
          <div class="logo">
            <img src="assets/img/new_logo.png" alt="Codesender Logo">
          </div>

          <div class="brand" style="margin-top:15px">
            Codesender
          </div>
        </div>
      </a>
    </div>
    <!-- Collect the nav links, forms, and other content for toggling -->
    <div class="collapse navbar-collapse" id="example">
      <ul class="nav navbar-nav navbar-right">
        <li>
          <a href="https://fb.me/codesender.pl">
            <i class="fa fa-facebook-square"></i>
            Odwiedź nas na Facebooku
          </a>
        </li>
        <!-- <li>
          <a href="#">
            <i class="fa fa-twitter"></i>
            Tweet
          </a>
        </li>
        <li>
          <a href="#">
            <i class="fa fa-pinterest"></i>
            Pin
          </a>
        </li> -->
      </ul>
    </div>
    <!-- /.navbar-collapse -->
  </div>
</nav>
<div class="wrapper">
  <div class="parallax filter-gradient blue" data-color="blue">
    <div class="container">
      <div class="row">
        <div class="col-md-7  hidden-xs">
          <div class="parallax-image">
            <img src="assets/img/showcases/showcase-2/mac1.png" />
          </div>
        </div>
        <div class="col-md-5">
          <div class="description text-center">
            <h2>Codesender zautomatyzuje wysyłkę produktów cyfrowych</h2>
            <br>
            <h5>Jestem w pełni automatycznym, intuicyjnym systemem wysyłki produktów cyfrowych (np. kodów, e-booków, doładowań,
              kart podarunkowych) sprzedawanych na platformie Allegro. Nie musisz martwić się o wysyłkę sprzedanych przedmiotów.
              Dostarczę je automatycznie po wykryciu wpłaty od kupującego.
            </h5>
            <div class="buttons">
              <a href="https://panel.codesender.pl/register" target="_blank" class="btn btn-fill btn-neutral">
                <i class="fa fa-mail-forward"></i> Utwórz bezpłatne konto teraz
              </a>
            </div>
            <p></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section section-gray section-clients">
    <div class="container text-center">
      <h4 class="header-text">Zaufaj nam</h4>
      <p>
        Nie trać czasu na rzeczy, które może za Ciebie wykonać automat. Nie ważne, czy wysyłasz jeden, czy tysiąc produktów dziennie.
        Rozwijaj swój biznes, wdrażaj nowe pomysły. Żmudną wysyłkę zostaw nam. Dołącz grona zadowolonych klientów naszego
        systemu!
        <br>
      </p>
      <!-- <div class="logos">
        <ul class="list-unstyled">
          <li>
            <img src="assets/img/logos/adobe.png" />
          </li>
          <li>
            <img src="assets/img/logos/zendesk.png" />
          </li>
          <li>
            <img src="assets/img/logos/ebay.png" />
          </li>
          <li>
            <img src="assets/img/logos/evernote.png" />
          </li>
          <li>
            <img src="assets/img/logos/airbnb.png" />
          </li>
          <li>
            <img src="assets/img/logos/zappos.png" />
          </li>
        </ul>
      </div> -->
    </div>
  </div>
  <div class="section section-presentation">
    <div class="container">
      <div class="row">
        <div class="col-md-5 hidden-xs">
          <div class="description">
            <h4 class="header-text">Natychmiastowa wysyłka</h4>
            <p>Wysyłka następuje natychmiastowo po zaksięgowaniu wpłaty od Kupującego. Dostawa trwa średnio <strong>45 sekund!</strong> co stawia nas w czołówce systemów automatycznej dostawy kodów.
            </p>
            <p>Stwórz katalog produktów, podłącz go do aukcji i gotowe.</p>
            <p>Klient nie zapłacił? Zapewniamy automatyczny system występowania o zwrot prowizji byś zaoszczędził czas i pieniądze</p>


          </div>
        </div>
        <div class="col-md-6 ">
          <img src="assets/img/showcases/showcase-2/mac2.png" style="margin-top:-50px" />
        </div>
      </div>
    </div>
  </div>

  <div class="section section-features">
    <div class="container">
      <h4 class="header-text text-center">Dlaczego warto</h4>
      <div class="row">
        <div class="col-md-3">
          <div class="card card-blue">
            <div class="icon">
              <i class="pe-7s-rocket"></i>
            </div>
            <div class="text">
              <h4>Automatyczna wysyłka</h4>
              <p>System na bierząco monitoruje wpłaty od Kupujących, aby w ciągu minuty dostarczyć zamówiony towar.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-blue">
            <div class="icon">
              <i class="pe-7s-graph1"></i>
            </div>
            <h4>Statystyki</h4>
            <p>Sprzedaż wymaga monitoringu. Dlatego zapewniamy moduł przejrzystych statystyk sprzedaży oraz wysyłki.</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-blue">
            <div class="icon">
              <i class="pe-7s-help2"></i>
            </div>
            <h4>System Pomocy</h4>
            <p>Jeśli Kupujący ma problem z produktem lub poprostu wymaga wparcia technicznego ma do dyspozycji przejrzysty System
              Pomocy.
            </p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card card-blue">
            <div class="icon">
              <i class="pe-7s-piggy"></i>
            </div>
            <h4>Niskie koszty</h4>
            <p>Tylko <strong>15 gr</strong> za wysłany kod.
            <br/>Tworząc konto otrzymujesz <strong>10 darmowych wysyłek</strong>, aby móc się przekonać, czy system spełnia Twoje oczekiwania.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--<div class="section section-testimonial">
    <div class="container">
      <h4 class="header-text text-center">Co sądzą o nas inni</h4>
      <div id="carousel-example-generic" class="carousel fade" data-ride="carousel">
        <div class="carousel-inner" role="listbox">
          <div class="item">
            <div class="mask">
              <img src="assets/img/faces/face-1.png">
            </div>
            <div class="carousel-testimonial-caption">
              <p>Dariusz Kawalec, ekody.pl</p>
              <h3>"Nie wyobrażam sobie pracy bez Waszego systemu. Super, że jesteście!"</h3>
            </div>
          </div>
          <div class="item active">
            <div class="mask">
              <img src="assets/img/faces/face-1.png">
            </div>
            <div class="carousel-testimonial-caption">
              <p>Jacek, sprzedawca Allegro</p>
              <h3>"Kiedyś wysyłałem te wszystkie maile ręcznie tracąć na to cały dzień. Dziś robi to za mnie automat!"</h3>
            </div>
          </div>
          <div class="item">
            <div class="mask">
              <img src="assets/img/faces/face-1.png">
            </div>
            <div class="carousel-testimonial-caption">
              <p>Celina Ryś, Autorka</p>
              <h3>"Doskonały kontakt i wsparcie. System wdrożony w moim sklepie w ciągu kilku kliknięć!"</h3>
            </div>
          </div>
        </div>
        <ol class="carousel-indicators carousel-indicators-blue">
          <li data-target="#carousel-example-generic" data-slide-to="0" class="active"></li>
          <li data-target="#carousel-example-generic" data-slide-to="1"></li>
          <li data-target="#carousel-example-generic" data-slide-to="2"></li>
        </ol>
      </div>
    </div>
  </div>-->
  <div class="section section-no-padding">
    <div class="parallax filter-gradient blue" data-color="blue">
      <div class="parallax-background">
        <img class="parallax-background-image" src="assets/img/showcases/showcase-2/bg2.jpg">
      </div>
      <div class="info">
        <h1>Zarejestruj się za darmo już teraz!</h1>
        <p>10 darmowych wysyłek, abyś mógł przetestować możliwości sytemu.</p>
        <a href="https://panel.codesender.pl/register" target="_blank" class="btn btn-neutral btn-lg btn-fill">REJESTRACJA</a>
      </div>
    </div>
  </div>
  <div class="section section-gray section-clients">
    <div class="container text-center">
      <h4 class="header-text">Czekamy na kontakt</h4>
      <app-contact-form></app-contact-form>
    </div>
  </div>
  <footer class="footer">
    <div class="container">
      <nav class="pull-left">
        <ul>
          <li>
            <a href="#">
              Home
            </a>
          </li>
          <li>
            <a href="#">
              Kontakt
            </a>
          </li>
          <li>
            <a href="https://panel.codesender.pl">
              Panel
            </a>
          </li>
          <!-- <li>
            <a href="#">
              Blog
            </a>
          </li> -->
        </ul>
      </nav>
      <div class="social-area pull-right">
        <a class="btn btn-social btn-facebook btn-simple" href="https://fb.me/codesender.pl">
          <i class="fa fa-facebook-square"></i>
        </a>
        <!-- <a class="btn btn-social btn-twitter btn-simple">
          <i class="fa fa-twitter"></i>
        </a>
        <a class="btn btn-social btn-pinterest btn-simple">
          <i class="fa fa-pinterest"></i>
        </a> -->
      </div>
      <div class="copyright">
        &copy; 2018
        <a href="http://codesender.pl">Codesender</a>
      </div>
    </div>
  </footer>
</div>



// WEBPACK FOOTER //
// C:/Users/dtarc/source/repos/CODESENDER/web/src/app/app.component.html